import React, { useEffect, useState } from 'react'

import { PIICategoryParameterFormats, sendBatchToServer } from '../../assets/ts/data/pii/pii-category-parameter-formats'
import {
  PIICategoryTypeParametersList,
  addOrUpdatePIICategoryTypeParam,
} from '../../assets/ts/data/pii/pii-category-type-parameters'
import PageOverlayBusy from '../../components/page-overlay/page-overlay-busy'
import './switch.css'

interface Props {
  Enable?: boolean
  allFormats?: PIICategoryParameterFormats[] //Functionally needed if we ever want to toggle all items. 
  categories: PIICategoryTypeParametersList[]
  cid: number | undefined
  fetchPiiCategoryParameterFormatsMetadata: any
  fetchPiiCategoryTypeParameterMetadata: any
}

const InputSwitch = (props: Props) => {
  const {
    Enable = false,
    categories,
    cid,
    fetchPiiCategoryParameterFormatsMetadata,
    fetchPiiCategoryTypeParameterMetadata,
  } = props
  const [enableNewCat, setEnableNewCat] = useState(Enable)
  const [showPageOverlay, setShowPageOverlay] = useState(false)

  const enableNewCategory = async (cid: number, categories) => {
    setShowPageOverlay(true)

    try {
      // Find the category by CID
      const categoryIndex = categories.findIndex((category) => category.CID === cid)
      if (categoryIndex !== -1) {
        // Create a new array with updated values
        const newEditCategories = [...categories]
        newEditCategories[categoryIndex] = {
          ...newEditCategories[categoryIndex],
          ParamEnable: enableNewCat ? 'No' : 'Yes',
        }
       /* Functionally needed if we ever want to toggle all items. 
       const allItems = [...allFormats]
        const modifiedItems = allItems.map((item) => {
          if (item.PID === cid) {
            const modifiedItem = { ...item, FormatEnable: enableNewCat ? 'No' : 'Yes' }
            return modifiedItem
          }
          return item
        })
        await sendBatchToServer(modifiedItems) */
        await addOrUpdatePIICategoryTypeParam(newEditCategories[categoryIndex])
      } else {
        console.error('Category not found')
      }
    } catch (error) {
      console.error('Error in enableNewCategory', error)
    } finally {
      setShowPageOverlay(false)
      setEnableNewCat(!enableNewCat)
      fetchPiiCategoryTypeParameterMetadata()
      fetchPiiCategoryParameterFormatsMetadata()
    }
  }

  useEffect(() => {
    setEnableNewCat(Enable)
  }, [Enable])
  return (
    <>
      {showPageOverlay && <PageOverlayBusy />}
      <input
        checked={enableNewCat}
        className='react-switch-checkbox'
        data-id={cid}
        id={`react-switch-new-${cid}`}
        onChange={(e) => enableNewCategory(cid, categories)}
        type='checkbox'
      />
      <label
        className={
          enableNewCat ? 'react-switch-label bgcolor-primary' : 'react-switch-label bgcolor-5'
        }
        htmlFor={`react-switch-new-${cid}`}
      >
        <span className={'react-switch-button'} />
      </label>
    </>
  )
}

export default InputSwitch
